import React from 'react';
import { compact } from 'lodash';
import { ChevronRight, ChevronLeft } from 'react-feather';
import { Carousel } from 'react-responsive-carousel';
import classnames from 'classnames';

import quoteMarks from '../../../MOVEMETOCDN/quote-left.svg';
import { arrowStyles } from './styles';
import { TeachersAndCoachesFragment } from '../../../../graphql.schema';

import 'react-responsive-carousel/lib/styles/carousel.min.css';

export const StrapiTeacherAndCoaches = ({
  quoteText,
  quoteAuthor,
  quoteAuthorPosition,
  teachers,
  images,
  introHeading,
  introText,
}: TeachersAndCoachesFragment) => {
  const isV2 = process.env.GATSBY_IS_V2 === 'true';
  let styles = require('./teachers-and-coaches.module.scss');
  if (isV2) {
    styles = require('./teachers-and-coaches-v2.module.scss');
  }

  if (isV2) {
    return (
      <div className={styles.root}>
        <div className={styles.wrapper}>
          <div className={styles.leftContent}>
            <div className={styles.contentWrapper}>
              <p className={styles.quoteMarks}>“</p>
              <p className={classnames(styles.quote, 'is-text-1 black-2 mb-5')}>{quoteText}</p>
              <p className="is-text-3 black-2">{quoteAuthor}</p>
              <p className={classnames('is-text-3 black-2', styles.quoteAuthorPosition)}>{quoteAuthorPosition}</p>
              <h5 className="is-5 title brand-a mb-2">{introHeading}</h5>
              <p className={classnames('is-text-2 black-2', styles.introText)}>{introText}</p>

              <div className={styles.teachers}>
                {compact(teachers).map(({ teacherImage, teacherName, teacherPosition }, index) => (
                  <div key={index} className={styles.teachersCard}>
                    <div className={styles.teacherHolder}>
                      <div className={styles.teacherNamePopup} id={'teacherName_' + index}>
                        <p className={classnames('is-text-3', styles.teacherName)}>{teacherName}</p>
                        <p className={classnames('is-text-3')}>{teacherPosition}</p>
                      </div>
                      <svg width="19" height="25" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M18.6651 22.8166C13.9492 15.5156 14.7354 4.71544 15.7178 0L0 0C2.7506 16.793 11.6246 23.4251 15.7178 24.642C17.6828 25.5546 19.8441 24.642 18.6651 22.8166Z"
                          fill="var(--brand-a)"
                        />
                      </svg>
                    </div>
                    <img
                      className={styles.teacherImage}
                      key={teacherImage?.formats?.small?.url ?? teacherImage?.url}
                      src={teacherImage?.formats?.small?.url ?? teacherImage?.url}
                      width={teacherImage?.formats?.small?.width ?? teacherImage?.width}
                      height={teacherImage?.formats?.small?.height ?? teacherImage?.height}
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={styles.rightContent}>
            <div className={styles.carouselWrapper}>
              <Carousel
                className={styles.slider}
                autoPlay={false}
                showStatus={false}
                showThumbs={false}
                emulateTouch={true}
                infiniteLoop={true}
                showArrows={true}
                showIndicators={true}
                stopOnHover={true}
                interval={10000}
                renderArrowPrev={(onClickHandler, hasPrev) =>
                  hasPrev && (
                    <div onClick={onClickHandler} className={styles.carouselLeftButtonWrapper}>
                      <ChevronLeft style={{ ...arrowStyles, right: 15 }} size={30} className={styles.chevronIcon} />
                    </div>
                  )
                }
                renderArrowNext={(onClickHandler, hasNext) =>
                  hasNext && (
                    <div onClick={onClickHandler} className={styles.carouselRightButtonWrapper}>
                      <ChevronRight style={{ ...arrowStyles, right: 15 }} size={30} className={styles.chevronIcon} />
                    </div>
                  )
                }
                renderIndicator={(onClickHandler, isSelected, index, label) => {
                  return (
                    <li
                      key={`carousel-indicator-${index}`}
                      className={classnames(styles.indicator, { [styles.active]: isSelected })}
                      onClick={onClickHandler}
                      onKeyDown={onClickHandler}
                      value={index}
                      role="button"
                      tabIndex={0}
                      title={`${isSelected ? 'Selected ' : ''}${label} ${index + 1}`}
                      aria-label={`${isSelected ? 'Selected ' : ''}${label} ${index + 1}`}
                    />
                  );
                }}
              >
                {compact(images).map(({ url, caption, alternativeText }, idx) => (
                  <div key={`carousel-image-${idx}`} className={styles.imageWrapper}>
                    <img alt={alternativeText ?? caption ?? ''} src={url} className={styles.image} loading="lazy" />
                    <p className={styles.imageCaption}>{alternativeText ?? caption}</p>
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <div className="columns">
        <div className="column is-4 is-offset-1">
          <div className={styles.leftContent}>
            <p className={classnames(styles.quote, 'is-text-1 black-2 mb-3')}>
              {quoteText} <img src={quoteMarks} alt="" className={styles.quoteMarks} />
            </p>
            <p className={classnames(styles.paddingText, 'is-text-3 black-2')}>{quoteAuthor}</p>
            <p className={classnames(styles.paddingText, 'is-text-3 black-2 mb-5')}>{quoteAuthorPosition}</p>
            <h5 className={classnames(styles.paddingText, 'is-5 title brand-a')}>{introHeading}</h5>
            <p className={classnames(styles.paddingText, 'is-text-2 black-2 mb-5')}>{introText}</p>
            <div className={styles.teachers}>
              {compact(teachers).map(({ teacherImage, teacherName, teacherPosition }, index) => (
                <div key={index} className={styles.teachersCard}>
                  <div className={styles.teacherHolder}>
                    <div className={styles.teacherNamePopup} id={'teacherName_' + index}>
                      <strong className="is-text-3">{teacherName}</strong>
                      <p className="is-text-3">{teacherPosition}</p>
                    </div>
                  </div>
                  <img
                    className={styles.teacherImage}
                    key={teacherImage?.formats?.small?.url ?? teacherImage?.url}
                    src={teacherImage?.formats?.small?.url ?? teacherImage?.url}
                    width={teacherImage?.formats?.small?.width ?? teacherImage?.width}
                    height={teacherImage?.formats?.small?.height ?? teacherImage?.height}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={classnames('column is-6')}>
          <div className={styles.carouselWrapper}>
            <Carousel
              className={styles.slider}
              autoPlay={false}
              showStatus={false}
              showThumbs={false}
              emulateTouch={true}
              infiniteLoop={true}
              showArrows={true}
              showIndicators={true}
              stopOnHover={true}
              interval={10000}
              renderArrowPrev={(onClickHandler, hasPrev) =>
                hasPrev && (
                  <div onClick={onClickHandler} className={styles.carouselLeftButtonWrapper}>
                    <ChevronLeft style={{ ...arrowStyles, right: 15 }} size={30} className={styles.chevronIcon} />
                  </div>
                )
              }
              renderArrowNext={(onClickHandler, hasNext) =>
                hasNext && (
                  <div onClick={onClickHandler} className={styles.carouselRightButtonWrapper}>
                    <ChevronRight style={{ ...arrowStyles, right: 15 }} size={30} className={styles.chevronIcon} />
                  </div>
                )
              }
              renderIndicator={(onClickHandler, isSelected, index, label) => {
                return (
                  <li
                    key={`carousel-indicator-${index}`}
                    className={classnames(styles.indicator, { [styles.active]: isSelected })}
                    onClick={onClickHandler}
                    onKeyDown={onClickHandler}
                    value={index}
                    role="button"
                    tabIndex={0}
                    title={`${isSelected ? 'Selected ' : ''}${label} ${index + 1}`}
                    aria-label={`${isSelected ? 'Selected ' : ''}${label} ${index + 1}`}
                  />
                );
              }}
            >
              {compact(images).map(({ url, caption, alternativeText }, idx) => (
                <div key={`carousel-image-${idx}`} className={styles.imageWrapper}>
                  <img alt={alternativeText ?? caption ?? ''} src={url} className={styles.image} loading="lazy" />
                  <p className={styles.imageCaption}>{alternativeText ?? caption}</p>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
};
